// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Return_wrapper__1dtq-","link":"Return_link__84h7T"};